var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHospitalityChosen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 160,
    height: 198.486,
    viewBox: "0 0 160 198.486",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-2{fill:#13647b}.cls-4{fill:#4b4b4b}\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Hospitality_Chosen",
    transform: "translate(-867 -562)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_344",
    fill: "none",
    d: "M0 0H160V198H0z",
    transform: "translate(867 562)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_324",
    d: "M0 0H11V15H0z",
    className: "cls-2",
    transform: "translate(904 663)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_333",
    d: "M0 0H11V15H0z",
    className: "cls-2",
    transform: "translate(904 690)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_334",
    d: "M0 0H11V15H0z",
    className: "cls-2",
    transform: "translate(904 717)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_336",
    d: "M0 0H11V15H0z",
    className: "cls-2",
    transform: "translate(961 717)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_325",
    d: "M0 0H11V15H0z",
    className: "cls-2",
    transform: "translate(923 663)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_332",
    d: "M0 0H11V15H0z",
    className: "cls-2",
    transform: "translate(923 690)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_335",
    d: "M0 0H11V15H0z",
    className: "cls-2",
    transform: "translate(923 717)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_337",
    d: "M0 0H11V15H0z",
    className: "cls-2",
    transform: "translate(980 717)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_326",
    d: "M0 0H11V15H0z",
    className: "cls-2",
    transform: "translate(942 665)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_331",
    d: "M0 0H11V15H0z",
    className: "cls-2",
    transform: "translate(942 692)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_327",
    d: "M0 0H11V15H0z",
    className: "cls-2",
    transform: "translate(961 663)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_330",
    d: "M0 0H11V15H0z",
    className: "cls-2",
    transform: "translate(961 690)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_328",
    d: "M0 0H11V15H0z",
    className: "cls-2",
    transform: "translate(980 663)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_329",
    d: "M0 0H11V15H0z",
    className: "cls-2",
    transform: "translate(980 690)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2263",
    fill: "#dcdcdc",
    d: "M4957 656l6.48-22.4h91.539l6.481 22.4z",
    transform: "translate(-4062.3)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_350",
    transform: "translate(480.262 284.21)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_349"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2243",
    d: "M441.137 391.953c0 2.1-.007 4.192.007 6.287.01 1.442.586 2.005 2.054 2.012q4.818.018 9.641 0c1.513-.005 2.132-.606 2.132-2.076q0-8.793-.028-17.583c-.005-1.52-.577-2.089-2.112-2.1-3.158-.022-6.361-.022-9.521 0-1.637.012-2.138.518-2.146 2.165q-.009 2.889 0 5.779v3.133h-.025zm2.676-10.776h8.487v10.859h-8.483zm-.015 13.537h2.415c1.756 0 3.484-.005 5.213.008a.987.987 0 0 1 .761.274 1.233 1.233 0 0 1 .2.972 2.487 2.487 0 0 0-.013.292l.01.149a1.268 1.268 0 0 1-.21.995 1 1 0 0 1-.774.273h-7.6z",
    className: "cls-4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2244",
    d: "M481.481 400.246c3.325.031 6.647.039 9.9.022 1.49-.008 2.073-.605 2.081-2.127q.009-2.93 0-5.857v-2.6h-.026v-2.985c0-2.085.006-4.17-.006-6.254-.008-1.346-.566-1.928-1.863-1.942-3.322-.043-6.687-.043-10 0a1.876 1.876 0 0 0-.451 0 1.7 1.7 0 0 0-1.461 1.9c-.023 5.945-.029 11.98-.014 17.978a2.089 2.089 0 0 0 0 .3 1.7 1.7 0 0 0 1.84 1.565zm.836-19.082h8.48v10.874h-8.485zm.088 13.86l.044-.229h8.357v2.893h-6.226a1.327 1.327 0 0 1-.154-.011.669.669 0 0 0-.089-.008c-1.079-.05-1.649-.094-1.947-.473s-.213-.981.01-2.172z",
    className: "cls-4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2245",
    d: "M473.308 380.785c-.006-1.747-.542-2.283-2.3-2.293-1.559-.008-3.128-.012-4.7-.012s-3.138 0-4.7.012-2.068.537-2.078 2.1c-.013 2.093-.01 4.185-.008 6.277v5.141c0 2.014-.006 4.026 0 6.04.006 1.685.525 2.2 2.223 2.2q2.076 0 4.151-.006c1.708-.005 3.416-.01 5.124 0a1.845 1.845 0 0 0 2.3-2.24q.013-8.613-.012-17.219zm-11.133.346h8.45v10.937h-8.45zm8.482 16.459H462.2v-2.736h8.457z",
    className: "cls-4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2246",
    d: "M435.68 380.719c-.006-1.587-.606-2.21-2.142-2.225s-3.09-.021-4.64-.021-3.1.006-4.64.021c-1.8.019-2.355.575-2.36 2.386q-.023 8.549-.023 17.1c0 1.7.589 2.276 2.333 2.285 2.111.008 4.217 0 6.325-.005l2.83-.009c1.662 0 2.312-.652 2.318-2.312q.006-2.891 0-5.783v-5.737q.004-2.849-.001-5.7zm-10.923.673a1.381 1.381 0 0 1 1.063-.311c1.609.036 3.193.028 4.874.023q1.01 0 2.041-.006h.283v10.966h-8.559v-5.046c0-1.478.011-3.005-.022-4.506a1.5 1.5 0 0 1 .32-1.12zm8.317 16.275h-.283c-.723 0-1.441 0-2.158.007-.7 0-1.4.007-2.111.007-1.057 0-2.123-.008-3.173-.034a.953.953 0 0 1-.739-.283 1.2 1.2 0 0 1-.154-.974 1.76 1.76 0 0 0 .02-.409 1.132 1.132 0 0 1 .179-.964 1.105 1.105 0 0 1 .847-.316c1.706.012 3.412.008 5.165.008h2.408z",
    className: "cls-4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2247",
    d: "M500.867 400.262c3.255.027 6.5.028 9.678.007a2.226 2.226 0 0 0 .588 0 1.9 1.9 0 0 0 1.6-2.159v-5.826l-.027-2.9v-2.933c0-1.955.007-3.91 0-5.865-.008-1.465-.593-2.07-2.021-2.09-3.243-.038-6.531-.038-9.77 0a2.008 2.008 0 0 0-.441 0 1.779 1.779 0 0 0-1.54 1.985c-.022 5.866-.029 11.827-.016 17.756a1.923 1.923 0 0 0-.005.44 1.764 1.764 0 0 0 1.954 1.585zm.71-19.093h8.466v10.9h-8.466zm-.086 14.785a1.265 1.265 0 0 1 .244-.982 1.1 1.1 0 0 1 .856-.272c1.52.02 3.04.018 4.562.012h1.765c.167 0 .334.015.514.03l.413.032.076.128a1.87 1.87 0 0 1 .174.387c.132 1.19.187 1.706-.122 2.051s-.835.341-1.887.341h-.018l-1.406-.007c-1.3-.01-2.645-.019-3.963.022h-.085a1.138 1.138 0 0 1-.853-.286 1.527 1.527 0 0 1-.268-1.18c.007-.089.001-.183-.002-.276z",
    className: "cls-4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2248",
    d: "M454.995 413.551c0-2.113.007-4.228-.011-6.341-.011-1.4-.565-1.949-1.974-1.958-1.8-.011-3.612-.016-5.409-.016q-2.25 0-4.469.011c-1.423.008-1.952.535-1.952 1.948-.018 5.912-.018 11.906 0 17.816 0 1.391.54 1.911 1.979 1.918q4.821.015 9.641.008c1.589 0 2.153-.568 2.16-2.158q.009-2.887 0-5.777v-3.209h.032zm-11.185-5.67h8.566v2.075c0 2.754 0 5.356-.028 8.014l-.011.076a1.127 1.127 0 0 1-.778.766c-1.559.032-3.057.038-4.593.038h-3.156zm8.571 15.317c-.025.146-.033.293-.046.481l-.049.629h-8.466v-2.851h3.734a8.713 8.713 0 0 1 .98.013 20.125 20.125 0 0 0 2.156-.033 1.669 1.669 0 0 1 1.438.366 1.584 1.584 0 0 1 .253 1.397z",
    className: "cls-4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2249",
    d: "M493.436 407.307c-.006-1.577-.51-2.085-2.076-2.093-2.845-.01-5.949 0-9.772.031a2.169 2.169 0 0 0-.3-.021 1.745 1.745 0 0 0-.231.015 1.647 1.647 0 0 0-1.395 1.861c-.022 6.005-.023 12.009-.005 17.885.005 1.338.622 1.938 2 1.945q4.889.012 9.777 0c1.467-.005 1.989-.537 1.995-2.034q.009-2.931 0-5.865v-5.958q.012-2.885.007-5.766zm-11.2.542h8.533v11.014h-5.981c-1.188 0-1.8-.012-2.167-.377-.385-.38-.385-1.013-.385-2.277zm8.541 16.441h-8.433v-2.8h8.433z",
    className: "cls-4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2250",
    d: "M512.712 407.255c-.009-1.406-.625-2.01-2.061-2.018q-4.756-.025-9.515-.031c-1.543 0-2.2.651-2.2 2.172q-.018 8.732 0 17.462c0 1.476.622 2.081 2.131 2.088q4.762.02 9.525 0c1.559-.008 2.113-.585 2.118-2.206q.006-2.85 0-5.7v-5.821c.007-1.979.01-3.961.002-5.946zm-11.152.644h8.495v10.867h-8.495zm8.513 16.385h-8.465l-.058-.533c-.018-.167-.032-.316-.056-.465a1.669 1.669 0 0 1 .244-1.443 1.738 1.738 0 0 1 1.468-.416c1.52.074 3.016.058 4.6.042.659-.006 1.321-.013 1.99-.013h.284z",
    className: "cls-4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2251",
    d: "M433.807 405.249c-3.028-.041-6.338-.049-10.126-.023h-.064a1.681 1.681 0 0 0-1.683 1.6 10.24 10.24 0 0 0-.066 1.325q0 8.311.027 16.617c.006 1.548.619 2.154 2.186 2.161q4.705.017 9.4 0c1.617-.006 2.191-.6 2.191-2.274l.024-11.567c0-1.927.006-3.854 0-5.781-.006-1.423-.572-2.038-1.889-2.058zm-9.275 2.641h8.5v10.855h-8.5zm8.518 16.476H429.62c-1.424 0-2.866-.009-4.286-.052-.451-.012-.842-.908-.835-1.326.006-.347.31-1.449.8-1.466 1.964-.067 3.891-.06 5.924-.057h1.822z",
    className: "cls-4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2252",
    d: "M421.89 434.2q-.014 8.551 0 17.1c0 1.8.536 2.33 2.378 2.339q4.578.02 9.156 0c1.7-.008 2.253-.575 2.253-2.337v-10.585q0-3.255-.006-6.52c0-1.715-.565-2.267-2.308-2.275q-2.289-.008-4.578-.008t-4.578.008c-1.754.009-2.317.561-2.317 2.278zm11.133 16.746h-8.485v-2.721h8.485zM424.5 435.51a1.292 1.292 0 0 1 .9-.967l.07-.011c1.864-.042 3.693-.041 5.627-.034h1.938v11.072h-3.742c-1.291 0-2.551-.006-3.827-.032l-.075-.012a1.283 1.283 0 0 1-.878-.907c-.064-3.062-.064-6.107-.013-9.109z",
    className: "cls-4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2253",
    d: "M460.435 424.865c.008 1.543.535 2.065 2.088 2.065q4.7.012 9.4 0c1.781 0 2.27-.492 2.278-2.266q.014-3.534.011-7.069v-4.039c0-.729.006-1.456.011-2.185.009-1.386.019-2.771 0-4.157-.014-1.326-.629-2-1.828-2q-4.938 0-9.877.022c-1.589.007-2.077.488-2.087 2.059-.009 1.95-.005 3.9 0 5.851v6.128l.004 5.591zm11.122-.559H463.1v-2.772h8.46zm-8.495-16.443h8.567v6.116c.006 1.209.012 2.459-.027 3.69-.011.34-.363 1.136-.8 1.136-1.475.035-2.929.042-4.426.042h-3.309z",
    className: "cls-4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2254",
    d: "M512.711 434.081c-.008-1.562-.6-2.145-2.183-2.152q-2.321-.007-4.639-.008t-4.64.008c-1.754.007-2.317.561-2.317 2.282q-.014 8.609 0 17.218c0 1.576.6 2.194 2.142 2.2 3.159.02 6.363.02 9.521 0 1.558-.011 2.113-.589 2.119-2.21q.006-2.889 0-5.778v-5.781q.002-2.886-.003-5.779zm-11.217 6.51v-4.479c0-.264.016-.528.032-.813l.038-.729h8.492v11H504.2c-2.581 0-2.707-.129-2.707-2.745zm8.573 10.372h-8.5v-2.717h8.5z",
    className: "cls-4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2255",
    d: "M493.435 434.138c-.008-1.6-.587-2.2-2.138-2.2s-3.134-.012-4.7-.012-3.141 0-4.7.012c-1.6.007-2.227.646-2.232 2.278-.017 5.715-.017 11.51 0 17.225 0 1.548.638 2.185 2.186 2.2 3.122.018 6.285.018 9.4 0 1.648-.011 2.18-.563 2.186-2.272q.008-2.852 0-5.7v-5.65q.004-2.944-.002-5.881zM482.25 436.8v-2.256h8.525v11.023h-3.325c-1.449 0-2.858-.005-4.292-.034a1.155 1.155 0 0 1-.878-.962c-.034-2.564-.032-5.094-.03-7.771zm8.558 14.172h-8.492v-2.728h8.493z",
    className: "cls-4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2256",
    d: "M454.6 452.945a1.8 1.8 0 0 0 .356-1.335c.016-5.835.016-11.712 0-17.507-.008-1.511-.672-2.159-2.218-2.166s-3.134-.014-4.7-.014-3.142.005-4.7.014-2.153.6-2.164 2.191c-.013 2.065-.01 4.13-.008 6.2v4.561c0 2.2-.006 4.394.013 6.6.009 1.521.609 2.145 2.069 2.156 3.2.025 6.447.025 9.648 0a2.025 2.025 0 0 0 .516 0 1.793 1.793 0 0 0 1.188-.7zm-2.3-1.956h-8.474v-2.724h8.474zm-.232-5.711a1.362 1.362 0 0 1-1.015.32h-.089c-1.607-.043-3.253-.035-4.843-.027q-.993.006-2 .007h-.255l-.027-.253c-.016-.152-.033-.284-.049-.4a5.425 5.425 0 0 1-.057-.585v-9.749h8.515l.062.56a5.881 5.881 0 0 1 .065.771v2.775c0 1.77-.007 3.6.021 5.4a1.593 1.593 0 0 1-.328 1.181z",
    className: "cls-4"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_306"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2097",
    d: "M433.1 355.726l1.564 3.169 3.5.508-2.533 2.464.6 3.483-3.128-1.644-3.128 1.644.6-3.483-2.536-2.464 3.5-.508z",
    className: "cls-4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2098",
    d: "M449.767 355.726l1.564 3.169 3.5.508-2.533 2.464.6 3.483-3.128-1.644-3.128 1.644.6-3.483-2.531-2.467 3.5-.508z",
    className: "cls-4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2099",
    d: "M466.43 355.726l1.564 3.169 3.5.508-2.531 2.467.6 3.483-3.128-1.644-3.128 1.644.6-3.483-2.531-2.467 3.5-.508z",
    className: "cls-4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2100",
    d: "M483.093 355.726l1.564 3.169 3.5.508-2.531 2.467.6 3.483-3.128-1.644-3.128 1.644.6-3.483-2.531-2.467 3.5-.508z",
    className: "cls-4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2101",
    d: "M499.755 355.726l1.564 3.169 3.5.508-2.531 2.467.6 3.483-3.128-1.644-3.128 1.644.6-3.483-2.532-2.47 3.5-.508z",
    className: "cls-4"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2257",
    d: "M541.12 466.892h-6.131c-4.777 0-9.718-.009-14.576.027a1.815 1.815 0 0 1-1.292-.356 1.781 1.781 0 0 1-.365-1.29c.024-22.549.026-45.415.006-67.963v-8.191-16.38a10.1 10.1 0 0 0-.285-2.345c-1.673-6.873-3.392-13.855-5.109-20.75-.388-1.574-.739-1.851-2.353-1.851h-90.588c-1.623 0-1.977.275-2.364 1.838q-2.421 9.781-4.832 19.563a13.837 13.837 0 0 0-.545 3.182q-.033 13.91-.012 27.851v12.221q0 26.406.006 52.812a1.784 1.784 0 0 1-.366 1.306 1.739 1.739 0 0 1-1.278.354c-4.51-.041-9.1-.033-13.536-.029h-5.765V469H541.12zm-122.9-107.137c.654-2.64 1.331-5.37 1.96-8.064a1.514 1.514 0 0 1 1.746-1.363h.005c28.64.025 58.13.026 87.651.011.733 0 1.361.081 1.6 1.079q1.517 6.289 3.078 12.571l1.313 5.333a5.667 5.667 0 0 1 .075.766l.009.291h-100.05zm58.209 107.137h-19.653c-1.76 0-1.883-.121-1.883-1.852v-1.911h21.54zm-17.073-14.772l-.006-5.455c0-1.956-.005-3.912 0-5.867a6.114 6.114 0 0 1 5.9-6.306 5.143 5.143 0 0 1 .527.005 6.083 6.083 0 0 1 6.293 5.866c.005.144.006.284 0 .427v6.022c0 3.952-.006 8.039.029 12.057a1.7 1.7 0 0 1-.369 1.292 1.655 1.655 0 0 1-1.2.355h-.117c-3.158-.067-6.362-.067-9.523 0a1.565 1.565 0 0 1-1.222-.347 1.713 1.713 0 0 1-.346-1.279c.047-2.257.041-4.551.034-6.77zm56.734 14.691H479.1v-3.974c0-1.023-.144-1.594-.467-1.909a2.692 2.692 0 0 0-1.9-.446h-2.075v-1.826q0-2.672.006-5.343c.008-4.258.015-8.662-.022-12.992a8.49 8.49 0 0 0-7.71-8.331 8.84 8.84 0 0 0-9.8 6.091 10.271 10.271 0 0 0-.339 2.684c-.022 4.464-.019 8.927-.017 13.388v6.329h-1.147c-.512-.005-.982-.008-1.447 0a1.669 1.669 0 0 0-1.244.346 1.638 1.638 0 0 0-.607 1.1 1.615 1.615 0 0 0 0 .361c-.022.983-.017 1.927-.011 2.9q0 .657.005 1.334v.283H415.3v-93.668h100.79z",
    className: "cls-4"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2258",
    fill: "none",
    stroke: "#4b4b4b",
    strokeMiterlimit: 10,
    strokeWidth: "2.551px",
    d: "M392 467v8h149v-8"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHospitalityChosen);
export default __webpack_public_path__ + "static/media/hospitality-chosen.7806de0586415208a7e8ce68ad987e5e.svg";
export { ForwardRef as ReactComponent };